import { render, staticRenderFns } from "./Customization.vue?vue&type=template&id=793e7313"
import script from "./Customization.vue?vue&type=script&lang=js"
export * from "./Customization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports